import * as React from "react";
import { Anchor, Bed, BriefcaseMedical, Droplet, FlaskConical, Fuel, LifeBuoy, Map, Settings, Utensils, Wrench, Zap } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
const categories = [{
  title: "Provisions & Bonded",
  description: "Coordination of fresh, frozen, and dry provisions through our global network of vetted food and beverage suppliers.",
  icon: Utensils
}, {
  title: "Deck Stores",
  description: "Facilitating procurement of ropes, rigging, and deck maintenance gear from specialized maritime equipment providers.",
  icon: Anchor
}, {
  title: "Engine Stores",
  description: "Connecting vessels with premium suppliers of mechanical components, tools, and valves for engine room efficiency.",
  icon: Wrench
}, {
  title: "Cabin Stores",
  description: "Management of cabin supply requirements, connecting you with providers of quality linens and hygiene products.",
  icon: Bed
}, {
  title: "Medical Supplies",
  description: "Brokerage of WHO-standard medical kits and pharmaceuticals through certified maritime health suppliers.",
  icon: BriefcaseMedical
}, {
  title: "Safety Equipment",
  description: "Coordination of safety equipment procurement, ensuring compliance through certified life-saving appliance partners.",
  icon: LifeBuoy
}, {
  title: "Nautical Publications",
  description: "Facilitating access to the latest navigational charts and instruments from authorized maritime publishers.",
  icon: Map
}, {
  title: "Marine Chemicals",
  description: "Sourcing coordination for specialized marine chemicals and water treatment solutions from leading manufacturers.",
  icon: FlaskConical
}, {
  title: "Lubricants & Oils",
  description: "Procurement facilitation of marine-grade lubricants and greases through our international network of energy partners.",
  icon: Droplet
}, {
  title: "Spare Parts",
  description: "Brokerage of OEM and high-quality replacement parts, connecting you directly with authorized machinery manufacturers.",
  icon: Settings
}, {
  title: "Electrical Supplies",
  description: "Coordination of marine-certified electrical components through specialized maritime power suppliers.",
  icon: Zap
}, {
  title: "Liferaft Recertification",
  description: "Strategic coordination of Liferaft recertification services across major global maritime hubs.",
  icon: Fuel
}, {
  title: "Machine Shop Works",
  description: "Facilitating connections with specialized machine shops for precision fabrication and component repair.",
  icon: Wrench
}, {
  title: "Electric Motor Rewinding",
  description: "Coordination of expert rewinding services for marine motors and generators through our technical service network.",
  icon: Zap
}, {
  title: "Industrial Safety Equipment (PPE)",
  description: "Supply of certified personal protective equipment and industrial safety gear for onboard and offshore operations, ensuring compliance with international standards.",
  icon: Zap
}];
export default function SupplyCategories() {
  return <section id="supply-categories-section" className="bg-background py-20 md:py-32">
      <div className="container mx-auto px-4 md:px-6">
        <div className="mb-16 flex flex-col items-center text-center">
          <h2 className="font-serif text-3xl font-bold tracking-tight text-foreground md:text-4xl lg:text-5xl">
            Maritime Supply Coordination Categories
          </h2>
          <p className="mt-4 max-w-[800px] font-sans text-lg text-muted-foreground">
            Venchandlers Nexus acts as your strategic maritime broker, coordinating sourcing, quotations, and logistics through a global network of trusted partners to ensure seamless procurement for commercial vessels.
          </p>
        </div>

        <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4 xl:grid-cols-5">
          {categories.map((category, i) => {
          const Icon = category.icon;
          return <Card key={i} data-index={i} className="group rounded-[2px] border-border/40 bg-card transition-colors duration-300 hover:bg-muted/40 hover:border-border/80">
                <CardHeader className="pb-4">
                  <div className="mb-4 inline-flex h-12 w-12 items-center justify-center rounded-[2px] bg-primary/5 text-primary transition-colors group-hover:bg-primary/10">
                    <Icon className="h-6 w-6" strokeWidth={1.5} />
                  </div>
                  <CardTitle className="font-sans text-lg font-semibold text-foreground">
                    {category.title}
                  </CardTitle>
                </CardHeader>
                <CardContent>
                  <CardDescription className="font-sans text-sm leading-relaxed text-muted-foreground">
                    {category.description}
                  </CardDescription>
                </CardContent>
              </Card>;
        })}
        </div>

        <div className="mt-20 flex flex-wrap justify-center gap-4">
          <Button asChild size="lg" className="rounded-[2px] bg-ring px-10 py-7 font-sans text-sm font-bold uppercase tracking-widest text-primary-foreground transition-all hover:bg-ring/90 hover:shadow-md">
            <Link to="/#request-quote-home">
              Request For Quote
            </Link>
          </Button>
          <Button asChild size="lg" className="rounded-[2px] bg-ring px-10 py-7 font-sans text-sm font-bold uppercase tracking-widest text-primary-foreground transition-all hover:bg-ring/90 hover:shadow-md">
            <Link to="/GalleryPage">
              Gallery
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}